<template>
  <funcionalidade-customizada @voltar="$router.go(-1)"></funcionalidade-customizada>
</template>
<script>
import FuncionalidadeCustomizada from '@/components/FuncionalidadeCustomizada/FuncionalidadeCustomizadaComponent'
export default {
  components: {
    FuncionalidadeCustomizada
  }
}
</script>
